import React from "react";

const FavoritePlusIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="18"
			viewBox="0 0 19 18"
			fill="none"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.57912 3.57912C0.80696 5.35127 0.806962 8.22451 2.57912 9.99667L9.45275 16.8703L9.49999 16.823L9.5473 16.8704L16.4209 9.99672C18.1931 8.22457 18.1931 5.35133 16.4209 3.57918C14.6488 1.80702 11.7755 1.80702 10.0034 3.57918L9.8536 3.72895C9.65834 3.92421 9.34176 3.92421 9.1465 3.72895L8.99667 3.57912C7.22451 1.80696 4.35127 1.80696 2.57912 3.57912ZM5.5 9.75C5.5 9.19771 5.94771 8.75 6.5 8.75H8.5V6.75C8.5 6.19771 8.94771 5.75 9.5 5.75C10.0523 5.75 10.5 6.19771 10.5 6.75V8.75H12.5C13.0523 8.75 13.5 9.19771 13.5 9.75C13.5 10.3023 13.0523 10.75 12.5 10.75H10.5V12.75C10.5 13.3023 10.0523 13.75 9.5 13.75C8.94771 13.75 8.5 13.3023 8.5 12.75V10.75H6.5C5.94771 10.75 5.5 10.3023 5.5 9.75Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default FavoritePlusIcon;
